import { render, staticRenderFns } from "./Customer-Dropdown.vue?vue&type=template&id=2ca5d7aa"
import script from "./Customer-Dropdown.vue?vue&type=script&lang=js"
export * from "./Customer-Dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports